"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Query = /** @class */ (function () {
    function Query() {
    }
    Query.prototype.buildURL = function (query) {
        return "".concat(window.location.origin, "/search/").concat(this.getQueryString(query));
    };
    Query.prototype.getQueryString = function (query) {
        var queryString = '';
        if (query.handles) {
            queryString += query.handles.reduce(function (acc, handle) {
                acc += "handle:".concat(handle, " ").concat(query.operator, " ");
                return acc;
            }, '');
        }
        if (query.tags) {
            queryString += query.tags.filter(function (tag) { return tag.value !== ''; }).reduce(function (acc, tag) {
                acc += "tag:".concat(tag.key, ": ").concat(tag.value, " ").concat(query.operator, " ");
                return acc;
            }, '');
        }
        if (query.type)
            queryString += "&type=".concat(query.type);
        if (query.view)
            queryString += "&view=".concat(query.view);
        return encodeURI("?q=".concat(queryString));
    };
    return Query;
}());
exports.default = new Query();
